'use client';

import { c as _c } from "react/compiler-runtime";
import { AnalyticsSkuViewed, type AnalyticsSkuViewedProps } from '@repo/platform-analytics/AnalyticsSkuViewed';
export function ProductCardAnalyticsWrapper(t0) {
  const $ = _c(6);
  const {
    children,
    skuViewedProps,
    wrapperProps
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== wrapperProps) {
    t1 = <div {...wrapperProps}>{children}</div>;
    $[0] = children;
    $[1] = wrapperProps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== skuViewedProps || $[4] !== t1) {
    t2 = <AnalyticsSkuViewed enabled={true} {...skuViewedProps}>{t1}</AnalyticsSkuViewed>;
    $[3] = skuViewedProps;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}